import { BasicInput, BasicInputProps } from '@/view/components/BasicInput'
import { ReactNode } from 'react'

interface InputProps extends BasicInputProps {
  label: string
  name: string
  error?: string
  icon?: ReactNode
}

export const Input = ({ label, name, error, icon, ...props }: InputProps) => {
  return (
    <div>
      <div className="rounded-xl border border-gray02">
        <div className="flex items-center gap-1 pl-2 pt-2 font-semibold">
          {icon}
          <p className="text-xs font-semibold text-black04 sm:text-sm">
            {label}
          </p>
        </div>
        <BasicInput
          style={{
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            borderRadius: '12px',
          }}
          name={name}
          className="mt-0 h-10 w-full text-sm font-medium placeholder:text-black04 focus:border-transparent focus:outline-none focus:ring-0 sm:text-base"
          {...props}
        />
      </div>
      {error && (
        <div className="mt-1 min-h-5 pl-2 text-sm font-light text-error">
          {error}
        </div>
      )}
    </div>
  )
}
